import React from "react";
import Button from "../../Button";
import Overlay from "../../Overlay";
import excalamation from "../../../assets/img/icons/table/excalamation.svg";

function LinkingDeactivateConfirm({ onConfirm, onCancel, open = true }) {
  const handleCloseDialog = () => {
    onCancel();
  };

  const handleConfirm = async () => {
    await onConfirm();
    onCancel();
  };

  return (
    <Overlay show={open} closable={true} onClick={handleCloseDialog}>
      <div className="delete-confirm-wrapper">
        <div className="delete-confirm-container">
          <div className="are-you-sure">
            <img src={excalamation} alt={"excalamation"} />
            <p>Désactiver le filtre de liaison</p>
          </div>

          <h1 className="popup-desc-content">
            Voulez-vous désactiver le filtre de liaison en cours ?
          </h1>

          <div className="delete-button-containers">
            <Button
              text={"Non"}
              onClick={handleCloseDialog}
              className={"action-button"}
            />
            <Button
              text={"Oui"}
              onClick={handleConfirm}
              className={"action-button agree-action-button"}
            />
          </div>
        </div>
      </div>
    </Overlay>
  );
}

export default LinkingDeactivateConfirm;
